import {Animatable} from "./Animatable";
import * as AssetHelpers from "./AssetHelpers";
import {ContainerExtensions} from "./ContainerExtensions";
import {IPoint} from "./Geom";
import {Mix} from "./Reflection";
import {Scalable} from "./Scalable";

const tempRect = new PIXI.Rectangle();
const tempMatrix = new PIXI.Matrix();

export class Sprite extends Mix(PIXI.Sprite, ContainerExtensions, Scalable, Animatable) {

    constructor(texture?: string | PIXI.Texture, anchor?: IPoint) {
        super();
        this.setLayoutTexture(texture || PIXI.Texture.EMPTY, anchor ? anchor.x : 0, anchor ? anchor.y : 0);
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        this.texture = (texture instanceof PIXI.Texture ? texture :
            texture ? AssetHelpers.texture(texture) : PIXI.Texture.EMPTY) || PIXI.Texture.EMPTY;
        this.anchor.x = anchorX;
        this.anchor.y = anchorY;
    }

    public setTexturePreservingTransform(texture: string | PIXI.Texture) {
        // updateTransform is not enough, this call updates worldTransform properly
        this.getBounds(false, tempRect);
        this.transform.localTransform.copy(tempMatrix);
        this.texture = (texture instanceof PIXI.Texture ? texture : AssetHelpers.texture(texture)) || PIXI.Texture.EMPTY;
        tempMatrix.decompose(this.transform);
    }

    public destroy(options?: PIXI.DestroyOptions | boolean): void {
        this.killTweens();
        super.destroy(options);
    }
}
